export default function ConsultationCTA() {
  return (
    <section className="relative py-32 overflow-hidden">
      <div className="absolute inset-0 bg-gray-900"></div>
      <div
        className="absolute inset-0 bg-teal-500 origin-top-left"
        style={{
          clipPath: 'polygon(0 0, 100% 30%, 100% 100%, 0 70%)',
        }}
      ></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 text-center">
        <h2 className="font-serif text-4xl lg:text-6xl font-bold text-white mb-6">
          Ready To Discuss Your Case?
        </h2>
        <p className="text-xl text-white/90 mb-12 max-w-3xl mx-auto">
          Free consultation. No obligation. We come to you.
        </p>
        <div className="flex flex-wrap justify-center gap-6">
          <a
            href="#consultation-form"
            className="inline-flex items-center px-10 py-5 bg-white text-gray-900 rounded-full text-lg font-semibold hover:bg-gray-100 transition-colors shadow-xl whitespace-nowrap"
          >
            <i className="ri-calendar-check-line mr-3 text-xl"></i>
            Schedule Consultation
          </a>
          <a
            href="tel:2166429007"
            className="inline-flex items-center px-10 py-5 bg-transparent border-2 border-white text-white rounded-full text-lg font-semibold hover:bg-white hover:text-gray-900 transition-colors whitespace-nowrap"
          >
            <i className="ri-phone-line mr-3 text-xl"></i>
            Call Now: 216-642-9007
          </a>
        </div>
        <div className="mt-12 flex flex-wrap justify-center gap-8 text-white/80 text-sm">
          <div className="flex items-center">
            <i className="ri-time-line mr-2 text-lg"></i>
            <span>Available 24/7</span>
          </div>
          <div className="flex items-center">
            <i className="ri-map-pin-line mr-2 text-lg"></i>
            <span>Home & Hospital Visits</span>
          </div>
          <div className="flex items-center">
            <i className="ri-shield-check-line mr-2 text-lg"></i>
            <span>Confidential Consultation</span>
          </div>
        </div>
      </div>
    </section>
  );
}